import UserMarkets from 'broker/components/UserMarkets/UserMarkets';

export default function MarketsPage() {
  return <UserMarkets />;
}
